<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->

    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ประเภทการเคลม:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'abcClaimTypeCode'"
                  :name="'abcClaimTypeCode'"
                  :select2-options="abcClaimTypeCodeOptions"
                  v-model="abcClaimTypeCode"
                  ref="apmrTypeCodeSelect2"
                  @selectChange="onClaimTypeCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div
                class="form-group"
                v-show="abcClaimTypeCode == 'BEER_CLAIM_TYPE_AGENT'"
              >
                <label class="label-required">ตัวแทนจำหน่าย:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'abcAgentCode'"
                  :name="'abcAgentCode'"
                  :select2-options="abcAgentCodeOptions"
                  v-model="abcAgentCode"
                  ref="abcAgentCodeSelect2"
                  @selectChange="onAgentCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>

              <div
                class="form-group"
                v-show="abcClaimTypeCode == 'BEER_CLAIM_TYPE_SHOP'"
              >
                <label class="label-required">ร้านค้า:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'abcShopCode'"
                  :name="'abcShopCode'"
                  :select2-options="abcShopCodeOptions"
                  v-model="abcShopCode"
                  ref="abcShopCodeSelect2"
                  @selectChange="onShopCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">อำเภอ:</label>
                <input
                  id="abcAmpher"
                  name="abcAmpher"
                  v-model="abcAmpher"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="อำเภอ"
                  disabled
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">จังหวัด:</label>
                <input
                  id="abcProvince"
                  name="abcProvince"
                  v-model="abcProvince"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="จังหวัด"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">เบอร์โทร:</label>
                <input
                  id="abcPhone"
                  name="abcPhone"
                  v-model="abcPhone"
                  type="text"
                  maxlength="450"
                  class="form-control"
                  placeholder="เบอร์โทร"
                  disabled
                />
              </div>
            </div>
          </div>

          <div
            class="kt-section kt-section--first"
            v-show="abcClaimTypeCode != null && (abcAgentCode != null || abcShopCode != null) && (abcAgentCode != '' || abcShopCode != '')"
          >
            <h3 class="kt-section__title">รายการสินค้าเคลม:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="15%">แบรนด์สินค้า</th>
                        <th class="text-center" width="15%">ชื่อสินค้า</th>
                        <th class="text-center" width="10%">BARCODE</th>
                        <th class="text-center" width="10%">รหัสทรัพย์สิน(เบียร์สด)</th>
                        <th class="text-center" width="15%">ปัญหาที่พบ</th>
                        <th class="text-center" width="5%">คำสั่ง</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-if="
                          abcClaimItems == null || abcClaimItems.length == 0
                        "
                      >
                        <td colspan="9" class="text-muted text-center">
                          คลิก + เพื่อเพิ่มรายการใหม่
                        </td>
                      </tr>
                      <template v-for="(item, i) in abcClaimItems">
                        <tr>
                          <td class="text-center">{{ i + 1 }}</td>
                          <td class="text-center">{{ item.productBrand }}</td>
                          <td class="text-center">{{ item.material }}</td>
                          <td class="text-center">{{ item.barcodeOld }}</td>
                          <td class="text-center">{{ item.depCode }}</td>
                          <td class="text-center">{{ item.problemType }}</td>
                          <td>
                            <center>
                              <button
                                type="button"
                                class="btn btn-outline-hover-warning btn-elevate btn-circle btn-icon"
                                @click.prevent="onEditItemClick(i)"
                              >
                                <i class="text-warning la la-edit"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
                                @click.prevent="onRemoveItemClick(i)"
                              >
                                <i class="text-danger la la-trash"></i>
                              </button>
                            </center>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                    <tfoot
                      v-if="abcClaimItems == null || abcClaimItems.length == 0"
                    >
                      <tr>
                        <td colspan="9">
                          <router-link
                            :to="'Add/AddItem/add_' + index"
                            tag="button"
                            title="เพิ่ม Claim Item"
                            class="btn btn-outline-brand"
                            v-if="this.$root.canShow(['ADMIN_BEER_CLAIM', 'AGENT_ADMIN_BEER_CLAIM'])"
                          >
                            <i class="fa fa-plus"></i> เพิ่ม Claim Item
                          </router-link>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";

export default {
  components: {
    select2,
    datepicker,
  },
  data: function() {
    var self = this;

    return {
      isEdit: false,
      abcClaimTypeCode: null,
      abcAgentCode: null,
      abcAgentCodeTmp: null,
      abcShopCode: null,
      abcAmpher: null,
      abcProvince: null,
      abcPhone: null,
      abcClaimItems: [],
      index: 0,

      // Configurations
      abcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      abcAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2AgentData",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      abcShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopData",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('File', file);
      formData.append('FolderName', 'BeerClaim');
      try {
        const response = await axios.post('/Api/File/FileUpload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async formSubmit(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (this.abcClaimItems == null || this.abcClaimItems.length == 0)
        return false;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      var cItems = [];
      for (let element of self.abcClaimItems) {
        let uploadedFiles = [];
        if (element.uploadFiles) {
          for (let file of element.uploadFiles) {
            if(file && file.fileDataContext){
              const uploadResponse = await self.uploadFile(file.fileDataContext);
              // console.log('uploadResponse',uploadResponse)
              uploadedFiles.push({
                contentType: file.fileDataContext.type,
                downloadUrl: uploadResponse.fileUrl,
                fileInfoId: uploadResponse.fileInfoId,
                fileName: file.fileDataContext.name,
                gridFsId: uploadResponse.gridFsId,
                sysName: '-',
              });
            }else if(file && file.claimItemPictureId){
              uploadedFiles.push({
                claimItemPictureId: file.claimItemPictureId,
                fileInfoId: file.fileInfoId,
              })
            }
          }
        }
        if(element.machineCategory === 'true'){
          element.machineCategory = true;
        }
        if(element.machineCategory === 'false'){
          element.machineCategory = false;
        }
        cItems.push({
          ProductBrandId: element.productBrandId,
          MaterialCode: element.materialCode,
          Barcode: element.barcode,
          ManufacturingDate: element.manufacturingDate
            ? element.manufacturingDate.format("DD/MM/YYYY")
            : null,
          Weight: element.weight,
          ProblemTypeCode: element.problemTypeCode,
          ProblemDesc: element.problemDesc,
          MachineTypeCode: element.machineTypeCode,
          MachineBarcode: element.machineBarcode,
          MachineCategory: element.machineCategory,
          Pressure: element.pressure,
          Temperature: element.temperature,
          PMDate: element.pmDate ? element.pmDate.format("DD/MM/YYYY") : null,
          JumpDate: element.jumpDate
            ? element.jumpDate.format("DD/MM/YYYY")
            : null,
          StandardInstallCode: element.standardInstallCode,
          AgentReceivedDate: element.agentReceivedDate.format("DD/MM/YYYY"),
          ShopReceivedDate: element.shopReceivedDate
            ? element.shopReceivedDate.format("DD/MM/YYYY")
            : null,
          Invoice: element.invoice,
          Pictures: uploadedFiles,
        });
      }

      axios
        .post("/Api/BeerClaim", {
          BeerClaimItems: cItems,
          ClaimTypeCode: this.abcClaimTypeCode,
          ClaimAgentCode:
            this.abcClaimTypeCode == "BEER_CLAIM_TYPE_AGENT"
              ? this.abcAgentCode
              : null,
          ClaimShopCode:
            this.abcClaimTypeCode == "BEER_CLAIM_TYPE_SHOP"
              ? this.abcShopCode
              : null,
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onAgentCodeChange: function(id, text, data, ref) {
      var self = this;
      if ( isArray(data) && data.length > 0 ) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
        self.abcAgentCodeTmp = self.abcAgentCode;
      }
    },
    onShopCodeChange: function(id, text, data, ref) {
      var self = this;
      if ( isArray(data) && data.length > 0 ) {
        self.abcAmpher = data[0].data.ampherName;
        self.abcProvince = data[0].data.provinceName;
        self.abcPhone = data[0].data.phone;
        self.abcAgentCodeTmp = data[0].data.agentCode;
      }
    },
    onClaimTypeCodeChange() {
      var self = this;
      self.abcAgentCode = null;
      self.abcShopCode = null;
      self.abcAmpher = null;
      self.abcProvince = null;
      self.abcPhone = null;
      self.abcClaimItems = [];

      $("#abcAgentCode")
        .val("")
        .trigger("change");

      $("#abcShopCode")
        .val("")
        .trigger("change");
    },
    onRemoveItemClick(index) {
      this.abcClaimItems.splice(index, 1);
    },
    onEditItemClick(index) {
      let router = this.$router;
      var item = this.abcClaimItems[index];
      if (this.abcClaimItems.length > 0) {
        router.push({
          path: "/BeerClaim/Claim/Add/AddItem/" + index,
        });
      }
      else {
        router.push({
          path: "/BeerClaim/Claim/Add",
        });
      }
    },
    handleBackButton(event) {
      const modalBackdrop = document.querySelector('.modal-backdrop');
      if(modalBackdrop !== null && modalBackdrop !== undefined && modalBackdrop !== ''){
        modalBackdrop.remove()
      }
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    window.addEventListener('popstate', this.handleBackButton);
    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        abcClaimTypeCode: "required",
        abcAgentCode: "required",
        abcShopCode: "required",
      },
      messages: {
        abcClaimTypeCode: "กรุณาเลือกประเภทการเคลม",
        abcAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
        abcShopCode: "กรุณาเลือกร้านค้า",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
  async destroyed() {
    window.removeEventListener('popstate', this.handleBackButton);
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/BeerClaim/AddBeerClaim.vue